(async () => {
    const { $hide, $show } = await importModule('Utils');
    const { Core } = await importModule('Core');

    customElements.define('collection-loader', class extends Core {
        elements = {
            select: 'x-select',
            input: '[data-sort-input]'
        };

        subscriptions = {
            'collection:loading': '_collectionLoadingHandler',
            'collection:updated': '_collectionUpdatedHandler',
            'collection:error': '_collectionUpdatedHandler'
        };

        render() {
            this.subscribe('collection:loading');
            this.subscribe('collection:updated');
            this.subscribe('collection:error');
        }

        _collectionLoadingHandler() {
            this.setAttribute('aria-busy', 'true');
            $show(this);
        }

        _collectionUpdatedHandler() {
            this.setAttribute('aria-busy', 'false');
            $hide(this);
        }
        
    })
})();
